// Opens the Size & Fit guide dialog from any [data-size-fit-trigger] in the
// document. The trigger renders inline next to the size dropdown in the variant
// picker, while the dialog itself lives in the size-fit-guide block — so this
// delegated listener bridges the two (mirrors the store-selector trigger pattern).
document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-size-fit-trigger]')) return;

  const dialog = document.querySelector('dialog-component.size-fit-guide');
  if (dialog && typeof dialog.showDialog === 'function') dialog.showDialog();
});
